import {Injectable} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {ModalController} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { encode, decode } from 'js-base64';
import { firstValueFrom } from 'rxjs';
import {Page} from './page.type';

@Injectable({
  providedIn: 'root'
})
export class PageController {
  pagesAll: ({ title: any; component: Page; iconSrc: string; icon?: undefined; } | { title: any; component: Page; icon: string; iconSrc?: undefined; })[] = [];
  pagesLogout: ({ title: any; component: Page; iconSrc: string; icon?: undefined; } | { title: any; component: Page; icon: string; iconSrc?: undefined; })[] = [];
  pagesAlertOnly: ({ title: any; component: Page; iconSrc: string; icon?: undefined; } | { title: any; component: Page; icon: string; iconSrc?: undefined; })[] = [];
  pagesTechnicOnly: ({ title: any; component: Page; iconSrc: string; icon?: undefined; } | { title: any; component: Page; icon: string; iconSrc?: undefined; })[] = [];
  pagesSupportOnly: ({ title: any; component: Page; iconSrc: string; icon?: undefined; } | { title: any; component: Page; icon: string; iconSrc?: undefined; })[] = [];
  pagesRelationOnly: ({ title: any; component: Page; iconSrc: string; icon?: undefined; } | { title: any; component: Page; icon: string; iconSrc?: undefined; })[] = [];
  page: typeof Page;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalController: ModalController,
    private translate: TranslateService,
    private location: Location
  ) {
    this.page = Page;
    this.onInit();
  }

  async onInit() {
    let translateData = await firstValueFrom(this.translate.get(['Navi.Center', 'Navi.Event', 'Navi.TechnicCenter', 'Navi.Patient', 'Navi.System', 'Navi.UserManagement', 'Navi.Login', 'Navi.Member']));
    translateData = Object.values(translateData);
    this.pagesAll = [
      {title: translateData[0], component: Page.Content, iconSrc: '/assets/icon/dashboard.svg'},
      {title: translateData[1], component: Page.Events, iconSrc: '/assets/icon/operations.svg'},
      {title: translateData[2], component: Page.ContentTechnical, icon: 'construct-outline'},
      {title: translateData[3], component: Page.Patients, icon: 'people-outline'},
      {title: translateData[4], component: Page.Systemcheck, icon: 'desktop-outline'},
      {title: translateData[5], component: Page.Accounts, icon: 'body-outline'}
    ];
    this.pagesLogout = [
      {title: translateData[6], component: Page.Login, icon: 'log-in-outline'}
    ];  
    this.pagesAlertOnly = [
      {title: translateData[0], component: Page.Content, iconSrc: '/assets/icon/dashboard.svg'},
      {title: translateData[4], component: Page.Systemcheck, icon: 'desktop-outline'}
    ];
    this.pagesTechnicOnly = [
      {title: translateData[2], component: Page.ContentTechnical, icon: 'construct-outline'},
      {title: translateData[4], component: Page.Systemcheck, icon: 'desktop-outline'}
    ];

    this.pagesSupportOnly = [
      {title: translateData[1], component: Page.Events, iconSrc: '/assets/icon/operations.svg'},
      {title: translateData[2], component: Page.ContentTechnical, icon: 'construct-outline'},
      {title: translateData[3], component: Page.Patients, icon: 'people-outline'},
      {title: translateData[4], component: Page.Systemcheck, icon: 'desktop-outline'}
    ];
  
    this.pagesRelationOnly = [
      {title: translateData[7], component: Page.RelationContent, icon: 'megaphone-outline'}
    ];
  }

  getStartPage(role: string) {
    switch (role) {
      case 'all':
        return Page.Content;
      case 'alertOnly':
        return Page.Content;
      case 'TechnicOnly':
        return Page.ContentTechnical;
      case 'supportOnly':
        return Page.Events;
      case 'relationOnly':
        return Page.RelationContent;
      default:
        return Page.Content;
    }
  }

  navigateRoot(url: string) {
    this.router.navigateByUrl(url, { replaceUrl: true });
  }

  navigateForward(url: string, params:any={id:null}) {

    if(params.id == null){
      return this.router.navigateByUrl(url, { replaceUrl: false });
    }else{
      return this.router.navigate([url, params.id]);
    }

  }

  back() {
    this.location.back();
  }

  getState() {
    return this.router.getCurrentNavigation();
  }

  getUrl() {
    return this.router.url;
  }

  async backButtonPressed() {
    // First: Check if there is a modal
    const url = this.router.url;
    const modal = await this.modalController.getTop();
    console.log('Backbutton PRESSED', modal, url);
    if (modal) {
      return await modal.dismiss();
    }

    return this.back();

  }

  decodeDataParams() {
    const paramsFromRoute = this.route.snapshot.queryParamMap.get('data');
    return this.decodeParams(paramsFromRoute);
  }

  encodeParams(obj: any): string {
    return obj ? encode(JSON.stringify(obj)) : '';
  }

  decodeParams(encodedString: string): any {
    try {
      const decodedString = JSON.parse(decode(encodedString));
      return decodedString;
    } catch (error) {
      console.error(error);
    }
    return null;
  }

  navigateWithQueryParams(url, params, forwardDirection = true) {
    if (forwardDirection) {
      this.navigateForward(url, params);
    } else {
      this.navigateRoot(url);
    }
  }
}
